<!-- ngx-skeleton-loader -->
<!-- <div class="item" *ngIf="!dataLoaded"><ngx-skeleton-loader count="3" appearance="facebook"> </ngx-skeleton-loader></div> -->
<!-- <div  mat-dialog-title>
  <h1>{{ (isEdit ? service.cid + '.update' : service.cid + '.create') | translate }}</h1>
<mat-icon>close</mat-icon>

</div> -->
<h1 mat-dialog-title>
  {{ (isEdit ? service.cid + '.update' : service.cid + '.create') | translate }}
  <mat-icon style="float: left; cursor: pointer;" (click)="closeDialog()">close</mat-icon>
</h1>
<div mat-dialog-content [ngClass]="{ 'overflow-hidden': isSubmitted }">
  <div class="form-container" ngClass.gt-md="form-spacing lg" [ngClass]="{ headerSmallSize: headerSmallSize }">
    <div class="overlay-form" *ngIf="(!loaded && isEdit) || isSubmitted || !LoadedAddForm">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <form fxFlex fxLayout="column" class="core-form-style" [formGroup]="form" #formRef>
      <div fxFlex fxLayout class="page_heading" *ngIf="service.page_heading">
        <span class="title">
          <app-new-breadcrumb *ngIf="showBreadcrumb"></app-new-breadcrumb>
        </span>
        <app-form-footer
          (submit)="formSubmission()"
          (saveAddNew)="formSubmission(true)"
          (cancel)="cancelFormSubmission()"
          [form]="form"
          [formValid]="formValid"
          [isSaveAddNew]="isSaveAddNew"
          [isEdit]="isEdit"
          [isClone]="isClone"
          [isSubmitted]="isSubmitted"
        ></app-form-footer>
      </div>

      <div fxFlex fxLayout>
        <mat-card fxFlex>
          <mat-card-content>
            <div fxFlex="" fxLayout="column" class="d-flex flex-items-center">
              <div fxFlex="" fxLayout="column" class="default-form">
                <div
                  *ngFor="let groups of service.formInputsCategorized | pairs; trackBy: trackByFn"
                  fxFlex
                  fxLayout="column"
                  class="flex-wrap-margin-fixer"
                  [ngStyle]="{ 'margin-right': '-' + gridGapSize }"
                >
                  <!-- default inputs Group start  aka (no tab group or tabs )-->
                  <ng-container *ngIf="groups['key'] === 'defaultGroup'">
                    <ng-container *ngFor="let tab of groups['value'] | pairs; trackBy: trackByFn">
                      <ng-container *ngFor="let section of tab['value'] | pairs; trackBy: trackByFn">
                        <div class="form-section defaultSection" fxFlex="" fxLayout="column">
                          <div class="form-section-title" *ngIf="section['key'] !== 'defaultSection'">
                            {{ section['key'] | translate }}
                          </div>
                          <div class="form-section-content flex-wrap" fxFlex="column wrap" [fxLayoutGap]="gridGapSize">
                            <ng-template
                              [ngTemplateOutlet]="formTemplateRef"
                              [ngTemplateOutletContext]="{ form: section['value'] }"
                            >
                            </ng-template>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <!-- default inputs Group start -->

                  <!-- Tabs Groups start -->
                  <ng-container *ngIf="groups['key'] !== 'defaultGroup'">
                    <mat-horizontal-stepper
                      [linear]="true"
                      labelPosition="bottom"
                      [selectedIndex]="service.getActiveTab(groups['key'])"
                      [ngClass]="groups['key']"
                      #stepper
                    >
                      <ng-container *ngFor="let tab of groups['value'] | pairs; let i = index">
                        <mat-step [completed]="steperComplete ? i === 0 : false">
                          <ng-template matStepLabel>
                            <!--                          <span class="badge bg-danger" *ngIf="sectionErrorsCount(tab['value']) > 0">-->
                            <!--                          </span>-->
                          </ng-template>
                          <div class="pt-5" fxFlex="" fxLayout="column">
                            <ng-container *ngFor="let section of tab['value'] | pairs; trackBy: trackByFn">
                              <div class="form-section" fxFlex="" fxLayout="column">
                                <div class="form-section-title" *ngIf="section['key'] !== 'defaultSection'">
                                  {{ section['key'] | translate }}
                                </div>
                                <div class="form-section-content flex-wrap" fxFlex [fxLayoutGap]="gridGapSize">
                                  <ng-template
                                    [ngTemplateOutlet]="formTemplateRef"
                                    [ngTemplateOutletContext]="{ form: section['value'] }"
                                  >
                                  </ng-template>
                                  <!--                                  <ng-container *ngFor="let field of section['value']">-->
                                  <!--                                    <ng-container *ngIf="field?.form && fieldShowConditions(field)">-->

                                  <!--                                      <app-core-form-content-->
                                  <!--                                        [cid]="service.cid"-->
                                  <!--                                        [service]="service"-->
                                  <!--                                        [field]="field"-->
                                  <!--                                        [form]="form"-->
                                  <!--                                        (showHideChanges)="showHideChanges($event)"-->
                                  <!--                                        [isEdit]="isEdit"-->
                                  <!--                                        [isClone]="isClone"-->
                                  <!--                                        [isSubmitted]="isSubmitted"-->
                                  <!--                                        (UpdateFormFieldValueEmitter)="UpdateFormFieldValue($event)"-->
                                  <!--                                        [fxFlex.gt-lg]="getInputGridSize(field?.form?.grid?.gt_lg, gridGapSize)"-->
                                  <!--                                        [fxFlex.lt-xl]="getInputGridSize(field?.form?.grid?.lt_xl, gridGapSize)"-->
                                  <!--                                        [fxFlex.lt-lg]="getInputGridSize(field?.form?.grid?.lt_lg, gridGapSize)"-->
                                  <!--                                        [fxFlex.lt-md]="getInputGridSize(field?.form?.grid?.lt_md, gridGapSize)"-->
                                  <!--                                        [fxFlex.lt-sm]="getInputGridSize(field?.form?.grid?.lt_sm, gridGapSize)"-->
                                  <!--                                      >-->
                                  <!--                                      </app-core-form-content>-->
                                  <!--                                    </ng-container>-->
                                  <!--                                  </ng-container>-->
                                </div>
                              </div>
                              <div class="stepper-actions" fxFlex="" fxLayout="row">
                                <button mat-button (click)="stepBack()" [disabled]="i === 0">
                                  {{ 'pagination.previous' | translate }}
                                </button>
                                <button
                                  mat-button
                                  (click)="groupTabCurrErrorsByKey(groups['value'], tab.key)"
                                  [disabled]="getLengthOfObject(groups['value']) - 1 === i"
                                >
                                  {{ 'pagination.next' | translate }}
                                </button>
                              </div>
                            </ng-container>
                          </div>
                        </mat-step>
                      </ng-container>
                    </mat-horizontal-stepper>
                  </ng-container>
                  <!-- Tabs Groups end -->
                </div>
              </div>
            </div>
          </mat-card-content>
          <mat-card-footer></mat-card-footer>
        </mat-card>
      </div>
      <div fxFlex *ngIf="page_heading" fxLayout class="page_footer">
        <span></span>
        <app-form-footer
          (submit)="formSubmission()"
          (saveAddNew)="formSubmission(true)"
          (cancel)="cancelFormSubmission()"
          [form]="form"
          [formValid]="formValid"
          [isSaveAddNew]="isSaveAddNew"
          [isEdit]="isEdit"
          [isClone]="isClone"
          [isSubmitted]="isSubmitted"
        ></app-form-footer>
      </div>
    </form>
  </div>

  <div class="dummyDataLoader" id="dummyDataLoader" *ngIf="service.dummyDataLoader">
    <button mat-icon-button (click)="loadDummyData()">
      <mat-icon color="warn">battery_unknown</mat-icon>
    </button>
  </div>
</div>

<div mat-dialog-content class="mat-dialog-actions">
  <app-form-footer
    (submit)="formSubmission()"
    (saveAddNew)="formSubmission(true)"
    (cancel)="cancelFormSubmission()"
    [form]="form"
    [formValid]="formValid"
    [isSaveAddNew]="isSaveAddNew"
    [isEdit]="isEdit"
    [isClone]="isClone"
    [isSubmitted]="isSubmitted"
  >
  </app-form-footer>
  <!--  <button mat-stroked-button color="warn" (click)="closeDialog()">خروج</button>-->
  <!--  <button mat-flat-button color="primary" (click)="formSubmission()" cdkFocusInitial>اعمل اللى انتا عاوزه</button>-->
</div>

<!-- Start Main Form Template -->

<!-- Define the recursive template. -->
<ng-template #formTemplateRef let-form="form" let-formGroup="formGroup" let-formArrayWrap="formArrayWrap">
  <ng-container *ngFor="let field of form; trackBy: trackByFn">
    <!-- Start not array -->
    <ng-container *ngIf="field?.form && field?.form?.formFieldType != 'formArray' && fieldShowConditions(field)">
      <!-- Initiate the recursive template rendering. -->
      <ng-container *ngIf="formGroup">
        <ng-template
          [ngTemplateOutlet]="fieldTemplateRef"
          [ngTemplateOutletContext]="{ field: field, formGroup: formGroup, formArrayWrap: formArrayWrap }"
        >
        </ng-template>
      </ng-container>
      <ng-container *ngIf="!formGroup">
        <ng-template [ngTemplateOutlet]="fieldTemplateRef" [ngTemplateOutletContext]="{ field: field }"> </ng-template>
      </ng-container>
    </ng-container>
    <!-- End not array -->
    <!-- Start Array -->
    <ng-container *ngIf="field?.form?.formFieldType == 'formArray'">
      <div [formGroup]="Form">
        <!-- // Initiate the recursive template rendering.  -->
        <div
          class="potato"
          [formArrayName]="field.form.name"
          *ngFor="let item of getArrayFormControls(field.form.name); let i = index"
        >
          <div
            fxFlex
            fxLayout="column"
            [formGroupName]="i"
            [hidden]="editId ? i !== editId : i < getArrayFormControls(field?.form?.name).length - 1"
          >
            <ng-template
              [ngTemplateOutlet]="formTemplateRef"
              [ngTemplateOutletContext]="{
                form: field['form']['arrayForm'],
                formGroup: { id: i },
                formArrayWrap: field['form']['name']
              }"
            >
            </ng-template>
            <!--            <button-->
            <!--              mat-flat-button-->
            <!--              color="primary"-->
            <!--              class="btn-danger"-->
            <!--              (click)="removeArrayItem(field['form']['name'], i)"-->
            <!--              [disabled]=""-->
            <!--            >-->
            <!--              &lt;!&ndash; <mat-icon class="mat-18">save</mat-icon> &ndash;&gt;-->
            <!--              {{ 'common.remove' | translate }}-->
            <!--            </button>-->
          </div>
        </div>
      </div>
      <div>
        <button
          mat-flat-button
          color="primary"
          class="btn-primary"
          (click)="addArrayItem(field['form']['arrayForm'], field['form']['name'])"
          [disabled]=""
        >
          <!-- <mat-icon class="mat-18">save</mat-icon> -->
          {{ 'common.add' | translate }}
        </button>
      </div>
      <ng-template
        [ngTemplateOutlet]="tableTemplateRef"
        [ngTemplateOutletContext]="{
          array: getArrayFormControls(field.form.name),
          arrayForm: field['form']['arrayForm'],
          formName: field.form.name
        }"
      >
      </ng-template>
    </ng-container>
    <!-- End Array -->
  </ng-container>
</ng-template>
<!-- End Main Form Template -->

<ng-template #tableTemplateRef let-array="array" let-arrayForm="arrayForm" let-formName="formName">
  <!--  {{ array.value }}-->
  <section class="mdl-grid d-block no-padding full-width" id="my-table">
    <div class="">
      <table class="mdl-data-table mdl-js-data-table mdl-data-table--selectable full-width" *ngIf="array.length > 1">
        <thead>
          <tr>
            <th class="mdl-data-table__cell--non-numeric" *ngFor="let item of getDisplayedColumns(arrayForm)">
              {{ item.name }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of array; let i = index" [hidden]="i === array.length - 1 || i === editId">
            <td class="mdl-data-table__cell--non-numeric" *ngFor="let keys of getDisplayedColumns(arrayForm)">
              <ng-container *ngIf="keys?.groupFields">
                <ng-container *ngFor="let group of keys?.groupFields">
                  <ng-container *ngIf="group.type === 'array'">
                    <span class="gray-tag">{{ item.value[group.prop] }}</span>
                  </ng-container>
                  <ng-container *ngIf="group.type === 'boolean'">
                    <!-- <span class="gray-tag" *ngFor="let key of keys?.groupFields">{{ item.value[key.prop] }}</span> -->

                    <div class="field-container">
                      <mat-slide-toggle color="primary" [checked]="item.value[keys?.name]" [disabled]="true">
                      </mat-slide-toggle>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!keys?.groupFields">
                <span class="red">{{ item.value[keys?.name] }}</span>
              </ng-container>
            </td>
            <td>
              <mat-icon class="icon-md main-color" (click)="stepperRowAction('edit', formName, i)">edit</mat-icon>
              <mat-icon class="icon-md warn" color="warn" (click)="stepperRowAction('delete', formName, i)"
                >delete
              </mat-icon>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <table mat-table [dataSource]="array.value" class="mat-elevation-z8"> -->
      <!-- Name Column -->
      <!-- <ng-container *ngFor="let item of getDisplayedColumns(array.value)" [matColumnDef]="item">
        {{ cid.item | translate }}
        <th mat-header-cell *matHeaderCellDef>{{ service.cid + '.' + item | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element[item] }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(array.value)"></tr>
      <tr mat-row *matRowDef="let row; columns: getDisplayedColumns(array.value)"></tr> -->
      <!-- </table> -->
    </div>
  </section>
</ng-template>

<!-- Start Single Field Template -->
<ng-template #fieldTemplateRef let-field="field" let-formGroup="formGroup" let-formArrayWrap="formArrayWrap">
  <ng-container *ngIf="field?.form && fieldShowConditions(field)">
    <ng-container *ngIf="formGroup && formArrayWrap">
      <app-core-form-content
        [cid]="service.cid"
        [service]="service"
        [field]="field"
        [form]="getArrayFormControls(formArrayWrap)[formGroup.id]"
        (showHideChanges)="showHideChanges($event)"
        [isEdit]="isEdit"
        [isClone]="isClone"
        [arrayIndex]="formGroup"
        [isSubmitted]="isSubmitted"
        (UpdateFormFieldValueEmitter)="UpdateFormFieldValue($event)"
        [fxFlex.gt-lg]="getInputGridSize(field?.form?.grid?.gt_lg, gridGapSize)"
        [fxFlex.lt-xl]="getInputGridSize(field?.form?.grid?.lt_xl, gridGapSize)"
        [fxFlex.lt-lg]="getInputGridSize(field?.form?.grid?.lt_lg, gridGapSize)"
        [fxFlex.lt-md]="getInputGridSize(field?.form?.grid?.lt_md, gridGapSize)"
        [fxFlex.lt-sm]="getInputGridSize(field?.form?.grid?.lt_sm, gridGapSize)"
      >
      </app-core-form-content>
    </ng-container>
    <ng-container *ngIf="!formArrayWrap">
      <app-core-form-content
        [cid]="service.cid"
        [service]="service"
        [field]="field"
        [form]="form"
        [stepperMode]="stepperMode"
        (showHideChanges)="showHideChanges($event)"
        [isEdit]="isEdit"
        [isClone]="isClone"
        [isSubmitted]="isSubmitted"
        (UpdateFormFieldValueEmitter)="UpdateFormFieldValue($event)"
        [fxFlex.gt-lg]="getInputGridSize(field?.form?.grid?.gt_lg, gridGapSize)"
        [fxFlex.lt-xl]="getInputGridSize(field?.form?.grid?.lt_xl, gridGapSize)"
        [fxFlex.lt-lg]="getInputGridSize(field?.form?.grid?.lt_lg, gridGapSize)"
        [fxFlex.lt-md]="getInputGridSize(field?.form?.grid?.lt_md, gridGapSize)"
        [fxFlex.lt-sm]="getInputGridSize(field?.form?.grid?.lt_sm, gridGapSize)"
      >
      </app-core-form-content>
    </ng-container>
  </ng-container>
</ng-template>
<!-- End Single Field Template -->
